<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="grupos"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Grupo Usuario</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-autocomplete
              v-model="consultaDto.extraParam"
              :items="catGrupos"
              :filter="customFilter"
              @change="GetGrupoUsuario"
              color="white"
              item-text="nombre"
              item-value="idGrupo"
              label="Grupo"
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <!-- ********** -->
            <v-dialog
              v-model="dialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on" @click="newItem" outlined
                  >Asignar usuario grupo</v-btn
                >
              </template>
              <v-card>
                <v-toolbar dark color="primary">
                  <v-btn icon dark @click="dialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title
                    ><span class="headline"
                      >Grupo Usuario</span
                    ></v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="newItem">Limpiar Controles</v-btn>
                  </v-toolbar-items>
                  <!-- <v-btn class="ma-2" @click="Limpiar()" outlined color="indigo">Limpiar Controles</v-btn> -->
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn @click="saveItem" dark text>
                      Grabar
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader>
                  <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-autocomplete
                          v-model="editedItem.idGrupo"
                          :items="catGrupos"
                          :filter="customFilter"
                          @change="GetGrupoUsuario"
                          color="white"
                          item-text="nombre"
                          item-value="idGrupo"
                          label="Grupo"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" lg="4">
                        <v-autocomplete
                          v-model="editedItem.idUsuario"
                          :items="catUsuarios"
                          :filter="customFilter"
                          color="white"
                          item-text="nombre"
                          item-value="idUsuario"
                          label="Usuario"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list>
              </v-card>
              <v-divider></v-divider>
            </v-dialog>
            <!-- ********** -->
 
     <!-- Dialog te confirmacion que se ha cargado el layout -->
              <v-dialog v-model="dialogconfirm" max-width="290">
                    <v-card>
                        <v-card-title class="headline">Buen trabajo</v-card-title>
                        <v-card-text>
                           Se ha cargado el layout, verificar el excel de estatus de los usuarios asignados a los grupos.
                            <br>
                           <v-avatar size="32px" tile>
                              <img
                                :src="`/580b57fcd9996e24bc43c452.png`"
                              >
                                    
                           </v-avatar>
                        </v-card-text>
                        
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        
                        <v-btn
                            color="green darken-1"
                            text
                             @click="dialogconfirm = false"
                        >
                            Aceptar
                        </v-btn>
                       
                        </v-card-actions>
                    </v-card>
                </v-dialog>

          <!-- DIALOG DE CARGA ASIGNACION MASIVA DE USUARIOS -->
                  
                    <div class="text-center">
                      <v-bottom-sheet v-model="sheet">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="default"
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            Carga masiva
                          </v-btn>
                        </template>
                        <v-list>
                          <v-subheader>Layout Grupo Usuario</v-subheader>
                            <v-container fluid>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-list-item
                                    v-for="tile in tiles"
                                    :key="tile.title"
                                    @click="descargaArchivo"
                                  >
                                    <v-list-item-avatar>
                                      <v-avatar size="32px" tile>
                                        <img
                                          :src="`/excel.png`"
                                          :alt="tile.title"
                                        >
                                    
                                      </v-avatar>
                                      
                                    </v-list-item-avatar>
                                  
                                    <v-list-item-title>{{ tile.title }}</v-list-item-title>
                                  </v-list-item>
                                </v-col>
                                </v-row>
                               <v-row>
                                  <v-col cols="6" sm="6" md="6">
                                    <v-file-input label="Selecciona archivo" v-model="file" outlined dense></v-file-input>
                                  </v-col>
                                   <v-col cols="6" sm="6" md="6">
                                    <v-spacer></v-spacer>
                                       <v-btn right @click="uploadFile">Subir archivo</v-btn>
                                  </v-col>
                               </v-row>
                            </v-container>
                             
                        </v-list>
                      </v-bottom-sheet>
                    </div>
          </v-toolbar>
        </template>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.name">
              <td>
                <div>
                  <v-icon small class="mr-2" @click="editItem(item)">
                    edit
                  </v-icon>
                  <v-icon small @click="deleteItem(item)">
                    delete
                  </v-icon>
                </div>
              </td>
              <td>{{ item.nombreGrupo }}</td>
              <td>{{ item.nombreUsuario }}</td>
              <td>{{ item.noEmpleado }}</td>
             <td>
                  <v-icon class="mr-2">
                      {{ item.vigencia ? 'done_outline' : 'highlight_off' }}
                   </v-icon>
             </td>
            </tr>
          </tbody>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Resetear</v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      grupos: [],
      catUsuarios: [],
      catGrupos: [],
      dialogconfirm: false,
    sheet: false,
    tiles: [
      { img: 'messenger.png', title: 'Descarga' },
      // { img: 'messenger.png', title: 'Subir' },
    ],

      editedItem: {},
      dialogFecha: false,

      consultaDto: {
        Skip: 0,
        Take: 100,
        descending: true,
        sortBy: "",
        search: "",
        extraParam: "3",
      },
      consultaDtoUser: {
        Skip: 0,
        Take: 200,
        descending: true,
        sortBy: "",
        search: "",
      },

      dialog: false,
      dialogMasiva: false,
      headers: [
        { text: " ", value: " " },
        { text: "Grupo", value: "nombreGrupo" },
        { text: "Usuario", value: "nombreUsuario" },
        { text: "No Empleado", value: "noEmpleado" },
        { text: 'Vigencia', value: 'vigencia' },
      ],
      rulesIMG: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "La imagen no puede ser mayor de 2 MB!",
      ],
      rulesPDF: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "El PDF no puede ser mayor de 2 MB!",
      ],
      file: null,
      search: "",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.Default();
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  methods: {
    Default() {
      let me = this
      me.$store.dispatch('setIsBusy', true)      
      me.GetGrupoUsuario()
      me.newItem()
      me.$axios
        .get("api/Grupos/Get")
        .then((r) => {
          if (r.data.exito) {
            me.catGrupos = r.data.datos
          }
        })
        .catch((e) => {
          console.log(e)
        })      
      var js = {
        consultaDto: me.consultaDtoUser
      }
      me.$axios
        .post("api/Usuario/Get", js)
        .then((r) => {
          if (r.data.exito) {
            me.catUsuarios = r.data.datos
            console.log('me.catUsuarios')
            console.log(me.catUsuarios)
          }
          // this.$root.Mensaje(r.data.mensaje);
          me.$store.dispatch('setIsBusy', false)
        })
        .catch((e) => {
          console.log(e);
        });
    },
    GetGrupoUsuario(e) {
      let me = this;
      me.consultaDto.extraParam = me.consultaDto.extraParam.toString();
      me.$store.dispatch('setIsBusy', true);
      me.$axios
        .post("api/GrupoUsuario/Get", me.consultaDto)
        .then((r) => {
          if (r.data.exito) {
            me.grupos = r.data.datos;
          }
          me.$store.dispatch('setIsBusy', false);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.nombre.toLowerCase();
      const searchText = queryText.toLowerCase();
      let r = textOne.indexOf(searchText) > -1;
      return r;
    },
    newItem() {
      let me = this;
      me.$axios
        .get("api/GrupoUsuario/New")
        .then((r) => {
          me.editedItem = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    descargaArchivo() {
      let me = this;

      debugger
      me.$store.dispatch('setIsBusy', true)    

      var url = "api/GrupoUsuario/downloadFile"

       me.$axios({
            url: url,
            method: 'GET',
            crossDomain: true,
            responseType: 'blob',
          }).then((response) => {
                  const url = window.URL.createObjectURL(new Blob([response.data]))
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute('download', 'GrupoUsuario.xlsm')
                  document.body.appendChild(link)
                  link.click()
                  me.$store.dispatch('setIsBusy', false)
                 })
    },
    uploadFile(){
      debugger
            let me = this;
            me.$store.dispatch('setIsBusy', true)
            if(me.file === null)
            { 
            
              me.$root.Mensaje("Elija un layout");
              me.$store.dispatch('setIsBusy', false)
              return;
            }
            let formData = new FormData();
            formData.append('file', me.file);
            
            me.$axios.post("api/GrupoUsuario/uploadFile", 
                formData, { headers: { 'Content-Type': 'multipart/form-data' }, file_name: "GrupoUsuario", responseType: 'blob'}
            ).then((response) => {
                  const url = URL.createObjectURL(new Blob([response.data], {
                      type: 'application/vnd.ms-excel.sheet.macroEnabled.12'
                  }))
                  me.file = null;
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute('download', "GrupoUsuario")
                  link.style = "display: none";
                  document.body.appendChild(link)
                  link.click()
                  me.$store.dispatch('setIsBusy', false)
                  me.dialogconfirm = true
                  me.GetGrupoUsuario();
              
             })
            .catch((error) =>  {
                //  this.$root.Mensaje(error.response.data
                const reader = new FileReader();
                        reader.onload = function() {
                            const data = this.result;
                            me.$root.Mensaje(data);
                        };
                        reader.readAsText(error.response.data);
                        me.file = null;
                        me.$store.dispatch('setIsBusy', false)
                  }
             );
      },

    editItem(item) {
      this.editedItem = item;
      this.dialog = true;
    },
    deleteItem(item) {
      let me = this;
      me.$store.dispatch('setIsBusy', true);
      me.$axios
        .get("api/GrupoUsuario/Delete?idGrupoUsuario=" + item.idGrupoUsuario)
        .then((s) => {
          if (s.data.exito) {
            me.$root.Mensaje("Usuario removido del Grupo");
          } else {
            me.$root.Mensaje(s.data.mensaje);
          }
          me.$store.dispatch('setIsBusy', false);
          me.dialog = false;
          me.GetGrupoUsuario();
        })
        .catch((e) => {
          this.$root.Mensaje(e.data.mensaje);
        });
    },
    saveItem() {
      let me = this;
      me.$store.dispatch('setIsBusy', true);
      var js = {
        IdGrupoUsuario: me.editedItem.idGrupoUsuario,
        IdGrupo: me.editedItem.idGrupo,
        IdUsuario: me.editedItem.idUsuario,
      };
      console.log(js);
      me.$axios
        .post("api/GrupoUsuario/Save", js)
        .then((s) => {
          if (s.data.exito) {
            me.$root.Mensaje("Usuario Asignado");
          } else {
            me.$root.Mensaje(s.data.mensaje);
          }
          me.GetGrupoUsuario();
          me.$store.dispatch('setIsBusy', false);
          me.dialog = false;
        })
        .catch((e) => {
          this.$root.Mensaje(e.data.mensaje);
        });
    },
  },
};
</script>
